export default __webpack_public_path__ + "static/media/Front-Private-Villa-in-Joun.17c161f4.jpg";